@if (riskEvaluation) {
    <div class="desktop-container" [ngClass]="{'last': isLast}">
        <div>
            <span class="intro">
                <div>
                    <h3 class="p-0 m-0">{{ title }}</h3>
                    <div class="flex items-center gap-2">
                        <p>Created <b>{{ createdDateLabel }}.</b></p>
                        <p>Status: <b>{{ riskEvaluation.status | riskEvaluationStatusLabel }}</b></p>
                    </div>
                </div>
            </span>
        </div>
        <p-tag styleClass="type-badge type-evaluation" value="Evaluation"></p-tag>
        <app-flight-card-cta
            class="w-full"
            [flight]="riskEvaluation"
            [type]="'riskEvaluation'"
            [canBeArchived]="true">
        </app-flight-card-cta>
    </div>

    <div class="mobile-container" (click)="$event.stopPropagation()">
        <app-flight-card-mobile [content]="'flex'">
            <ng-container title>{{ title }}</ng-container>
            <ng-container subtitle>
                <div class="mt-2">
                    <p-tag styleClass="type-badge type-evaluation" value="Evaluation"></p-tag>
                </div>
            </ng-container>
            <ng-container content>
                <div class="data-field">
                    <span>Created: <span class="font-bold">{{ createdDateLabel }}</span></span>
                </div>
                <div class="data-field">
                    <span>Status: <span class="font-bold">{{ riskEvaluation.status | riskEvaluationStatusLabel }}</span></span>
                </div>
            </ng-container>
            <ng-container actions>
                <app-flight-card-cta
                    class="w-full"
                    actions
                    [flight]="riskEvaluation"
                    [type]="'riskEvaluation'"
                    [canBeArchived]="true">
                </app-flight-card-cta>
            </ng-container>
        </app-flight-card-mobile>
    </div>
}
